module.exports = __webpack_public_path__ + "img/ic_32_sport_fussball.229f110d.svg";